<template>
  <nav id="nav">
    <ul>
      <li>
        <router-link to="/">
          Home
        </router-link>
      </li>

      <li>
        <a class="link_button" href="https://thelongesttale.com">
          THE LONGEST TALE
        </a>
      </li>

      <li>
        <router-link to="/playtest">
          Playtest
        </router-link>
      </li>

      <li>
        <router-link to="/mission">
          Our Mission
        </router-link>
      </li>

      <li>
        <router-link to="/news">
          News
        </router-link>
      </li>

      <!--<li>
        TODO: link to etsy store or similar
        <router-link to="/store">
          Store
        </router-link>
      </li>-->
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'MainNavV2',
  props : {
    hamburger: Boolean,
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/custom.scss";
#nav {
  align-items: center;
}

#main_layout.md #nav {
  flex-basis: 40%;
}

#main_layout.sm #nav,
#main_layout.xs #nav{
  flex-basis: 60%;
}

#nav ul{
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  margin-bottom: 0;
  margin-right: 24px;
}

#main_hamburger #nav ul{
  flex-direction: column;
  margin-right: unset;
  padding-top: 20px;
}

#nav li{
  list-style-type: none;
  padding: 0 16px;
}

#main_layout_v2.lg #nav li{
  padding: 0 8px;
}

#main_hamburger #nav li,
#main_hamburger #nav li,
#main_hamburger #nav li{
  text-align: center;
  padding-top: unset;
  padding-left: 10px;
  padding-bottom: 20px;
  padding-right: 10px;
}

#nav a{
  font-family: Bricolage Grotesque ExtraBold;
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-decoration: none;
  color: $white;
}
</style>
